import _get from "lodash/get.js";
export function getTypeValue(destination) {
    const { value , type  } = destination ?? {};
    /* Type zone when is ZONE */ if (type === 'ISL' && value) {
        return {
            value: value.replace('ZON_', ''),
            type: 'ZON'
        };
    }
    return {
        value,
        type
    };
}
export const getFromAccommodationPassenger = (oldModel, key, defaultValue = '')=>_get(oldModel, `accommodation.${key}`, _get(oldModel, `passenger.${key}`, defaultValue));
export const getAccommodationLiteralsFromOldData = (oldModel)=>{
    const room = getFromAccommodationPassenger(oldModel, 'panel.Body.literals.room');
    const rooms = getFromAccommodationPassenger(oldModel, 'panel.Body.literals.rooms', room);
    const adults = getFromAccommodationPassenger(oldModel, 'panel.Body.literals.adults', getFromAccommodationPassenger(oldModel, 'panel.Body.adults.label.content'));
    const adult = getFromAccommodationPassenger(oldModel, 'panel.Body.literals.adult', adults);
    const children = getFromAccommodationPassenger(oldModel, 'panel.Body.literals.children', getFromAccommodationPassenger(oldModel, 'panel.Body.children.label.content'));
    const kid = getFromAccommodationPassenger(oldModel, 'panel.Body.literals.kid', children);
    return {
        accommodationLabel: getFromAccommodationPassenger(oldModel, 'input.label.content'),
        accommodationTitle: getFromAccommodationPassenger(oldModel, 'panel.Header.title'),
        discountsLabel: _get(oldModel, 'discount.literals.inputLabel', getFromAccommodationPassenger(oldModel, 'panel.Body.literals.discounts')),
        addRoom: getFromAccommodationPassenger(oldModel, 'panel.Footer.actionAddRoom.content'),
        roomLabel: `${room} #number#`,
        adultLabel: adult,
        adultsLabel: adults,
        adultsDescription: getFromAccommodationPassenger(oldModel, 'panel.Body.adults.label.description'),
        childLabel: kid,
        childrenLabel: children,
        childrenDescription: getFromAccommodationPassenger(oldModel, 'panel.Body.children.label.description'),
        agesDescription: getFromAccommodationPassenger(oldModel, 'panel.Body.children.labelAges'),
        agesLabel: getFromAccommodationPassenger(oldModel, 'panel.Body.children.ages.title'),
        adultRoom: `{adult} ${adult}, {room} ${room}`,
        adultsRoom: `{adult} ${adults}, {room} ${room}`,
        adultChildRoom: `{adult} ${adult}, {child} ${kid}, {room} ${room}`,
        adultsChildRooms: `{adult} ${adults}, {child} ${kid}, {room} ${rooms}`,
        adultChildrenRoom: `{adult} ${adult}, {child} ${children}, {room} ${room}`,
        adultsChildrenRoom: `{adult} ${adults}, {child} ${children}, {room} ${room}`,
        adultsChildrenRooms: `{adult} ${adults}, {child} ${children}, {room} ${rooms}`,
        adultAmountInfo: `#number# ${adult}`,
        adultsAmountInfo: `#number# ${adults}`,
        childAmountInfo: `#number# ${kid}`,
        childrenAmountInfo: `#number# ${children}`,
        roomInfo: `#adults# #children# #number# ${room}`,
        roomsInfo: `#adults# #children# #number# ${rooms}`,
        errorMaxRooms: '',
        errorMaxPeople: '',
        discountTitle: getFromAccommodationPassenger(oldModel, 'literals.passengersDiscounts', getFromAccommodationPassenger(oldModel, 'literals.labelBonuses', getFromAccommodationPassenger(oldModel, 'panel.Body.literals.discounts', getFromAccommodationPassenger(oldModel, 'panel.Body.resident.label.content')))),
        bonusLabel: getFromAccommodationPassenger(oldModel, 'literals.labelBonuses', getFromAccommodationPassenger(oldModel, 'panel.Body.bonuses.label.content', getFromAccommodationPassenger(oldModel, 'panel.Body.literals.discounts'))),
        accept: getFromAccommodationPassenger(oldModel, 'panel.Footer.actionAccept.content'),
        discountLabel: getFromAccommodationPassenger(oldModel, 'literals.labelResident', getFromAccommodationPassenger(oldModel, 'panel.Body.resident.label.content', getFromAccommodationPassenger(oldModel, 'panel.Body.literals.discounts'))),
        noResultsText: '',
        discountsTitle: getFromAccommodationPassenger(oldModel, 'literals.labelResident', getFromAccommodationPassenger(oldModel, 'panel.Body.literals.discounts', getFromAccommodationPassenger(oldModel, 'panel.Body.resident.label.content'))),
        adultsAges: getFromAccommodationPassenger(oldModel, 'panel.Body.adults.label.description', ''),
        childAges: getFromAccommodationPassenger(oldModel, 'panel.Body.children.label.description', ''),
        agePersonLabel: getFromAccommodationPassenger(oldModel, 'panel.Body.literals.child', '')
    };
};
export const getAccommodation = (oldModel)=>{
    const adultsMin = getFromAccommodationPassenger(oldModel, 'panel.Body.adults.config.data.min', '1');
    const adultsMax = getFromAccommodationPassenger(oldModel, 'panel.Body.adults.config.data.max', '9');
    const adultsValue = getFromAccommodationPassenger(oldModel, 'panel.Body.adults.config.data.value', '1');
    const childrenMin = getFromAccommodationPassenger(oldModel, 'panel.Body.children.config.data.min', '1');
    const childrenMax = getFromAccommodationPassenger(oldModel, 'panel.Body.children.config.data.max', '9');
    const childrenValue = getFromAccommodationPassenger(oldModel, 'panel.Body.children.config.data.value', '1');
    const accommodation = {
        maxPeople: getFromAccommodationPassenger(oldModel, 'panel.Body.config.data.maxPeople'),
        maxRooms: getFromAccommodationPassenger(oldModel, 'panel.Body.config.data.maxRooms'),
        maxChildren: getFromAccommodationPassenger(oldModel, 'panel.Body.config.data.maxChildren'),
        adults: {
            min: adultsMin ? parseInt(adultsMin) : 1,
            max: adultsMax ? parseInt(adultsMax) : 9,
            value: adultsValue ? parseInt(adultsValue) : 1
        },
        children: {
            min: childrenMin ? parseInt(childrenMin) : 1,
            max: childrenMax ? parseInt(childrenMax) : 9,
            value: childrenValue ? parseInt(childrenValue) : 1,
            maxAge: 17,
            defaultAge: 7
        },
        rooms: [
            {
                adults: adultsValue ? parseInt(adultsValue) : 1,
                children: childrenValue ? parseInt(childrenValue) : 1,
                childrenAges: Array(childrenValue ? parseInt(childrenValue) : 1).fill(7)
            }
        ]
    };
    return accommodation;
};
export const getNewTypeFromOldData = (oldType)=>({
        airport: 'AER',
        station: 'EST',
        island: 'ISL',
        city: 'CIU',
        zone: 'ZON',
        hotel: 'HOT',
        port: 'PUE',
        pdi: 'PDI'
    })[oldType];

//# sourceMappingURL=index.js.map